var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a-lte-layout-page", { staticClass: "login-page" }, [
    _c("div", { staticClass: "login-box" }, [
      _c("div", { staticClass: "login-logo" }, [_vm._t("header")], 2),
      _vm._v(" "),
      _c("div", { staticClass: "card" }, [
        _c(
          "div",
          { staticClass: "card-body login-card-body" },
          [_vm._t("default")],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }